import { CALL_API, Schemas } from '../../common/middleware/api';

export const PARENT_DOCUMENTS_REQUEST = 'PARENT_DOCUMENTS_REQUEST';
export const PARENT_DOCUMENTS_SUCCESS = 'PARENT_DOCUMENTS_SUCCESS';
export const PARENT_DOCUMENTS_FAILURE = 'PARENT_DOCUMENTS_FAILURE';

export const PARENT_DOCUMENT_FETCH_REQUEST = 'PARENT_DOCUMENT_GET_REQUEST';
export const PARENT_DOCUMENT_FETCH_SUCCESS = 'PARENT_DOCUMENT_GET_SUCCESS';
export const PARENT_DOCUMENT_FETCH_FAILURE = 'PARENT_DOCUMENT_GET_FAILURE';

export const PARENT_DOCUMENT_CREATE_REQUEST = 'PARENT_DOCUMENT_CREATE_REQUEST';
export const PARENT_DOCUMENT_CREATE_SUCCESS = 'PARENT_DOCUMENT_CREATE_SUCCESS';
export const PARENT_DOCUMENT_CREATE_FAILURE = 'PARENT_DOCUMENT_CREATE_FAILURE';

export const PARENT_DOCUMENT_UPDATE_REQUEST = 'PARENT_DOCUMENT_UPDATE_REQUEST';
export const PARENT_DOCUMENT_UPDATE_SUCCESS = 'PARENT_DOCUMENT_UPDATE_SUCCESS';
export const PARENT_DOCUMENT_UPDATE_FAILURE = 'PARENT_DOCUMENT_UPDATE_FAILURE';

export const loadParentDocuments = ({ parentId, ...options }) => ({
	[CALL_API]: {
		types: [PARENT_DOCUMENTS_REQUEST, PARENT_DOCUMENTS_SUCCESS, PARENT_DOCUMENTS_FAILURE],
		endpoint: 'api/parentDocuments',
		request: { parentId, ...options },
		schema: Schemas.PARENT_DOCUMENT_ARRAY
	},
	parentId
});

export const createParentDocument = (parentDocument, history) => ({
	[CALL_API]: {
		types: [PARENT_DOCUMENT_CREATE_REQUEST, PARENT_DOCUMENT_CREATE_SUCCESS, PARENT_DOCUMENT_CREATE_FAILURE],
		endpoint: 'api/parentDocuments',
		method: 'POST',
		request: parentDocument,
		schema: Schemas.PARENT_DOCUMENT,
		form: 'parentDocument',
		transition: {
			history,
			successPath: (response) => {
				const { id, parentId } = response.entities.parentDocuments[response.result];
				return `/parents/${parentId}/parentDocuments/${id}`;
			}
		}
	}
});

export const updateParentDocument = (id, parentDocument) => ({
	[CALL_API]: {
		types: [PARENT_DOCUMENT_UPDATE_REQUEST, PARENT_DOCUMENT_UPDATE_SUCCESS, PARENT_DOCUMENT_UPDATE_FAILURE],
		endpoint: `api/parentDocuments/${id}`,
		method: 'PUT',
		request: parentDocument,
		schema: Schemas.PARENT_DOCUMENT,
		form: 'parentDocument'
	}
});